import { ConversationType } from "../constants/chat.constant";

const useChatLocalService = () => {
  const getSelectedConversation = (conversationType: ConversationType) => {
    return localStorage.getItem(conversationType);
  };

  /**
   * Saves the selected conversation ID for a conversation type to localStorage.
   * 
   * @param {string} conversationId - Conversation ID to save
   * @param {ConversationType} conversationType - Type of conversation
   */
  const saveSelectedConversation = (
    conversationId: string,
    conversationType: ConversationType
  ) => {
    localStorage.setItem(conversationType, conversationId);
  };

  /**
   * Clears all conversation IDs from localStorage for all conversation types.
   */
  const clearAll = () => {
    localStorage.removeItem(ConversationType.CHOP_GPT);
    localStorage.removeItem(ConversationType.POLICY_ASSISTANT);
  };

  return {
    getSelectedConversation,
    saveSelectedConversation,
    clearAll,
  };
};

export default useChatLocalService;
